module.exports = __webpack_public_path__ + "assets/adpoly-facility-meeting-rooms-bulk-upload-template.4a53d376.xlsx";